import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import imagesLoaded from 'vue-images-loaded'
import {TweenMax} from 'gsap'
import Vimeo from '@vimeo/player'

import {EventBus} from './helper/event-bus'

import svgridlayout from './components/svgridlayout.vue'
import svnewsletter from './components/svnewsletter.vue'
import svCookieLayer from './components/svCookieLayer.vue'
import historyStore from './components/visualization/history/store'
import svToggleContent from './components/svToggleContent.vue'

import VueGlide from 'vue-glide-js'

Vue.use(VueGlide)

require('../styles/screen.scss')

window.$ = window.jQuery = require('jquery')
window.Box = require('t3js')
window.Vimeo = Vimeo
window.imagesLoaded = require('imagesloaded/imagesloaded')
require('../js/vendor/scrolloverflow.min.js')
require('../js/vendor/jquery.fullpage.min.js')
require('../js/vendor/jquery.chocolat.min.js')
require('../js/vendor/jquery.bxslider.min.js')

var req = require.context('../js/modules', true, /\.js$/)
req.keys().forEach(function (key) {
    req(key)
})

require('../images/icons/twitter.svg')
require('../images/icons/facebook.svg')
require('../images/icons/instagram.svg')
require('../images/icons/linkedin.svg')
require('../images/icons/mail.svg')
require('../images/icons/pfeil.svg')
require('../images/icons/facebook.svg')
require('../images/icons/whatsApp.svg')
require('../images/icons/xing.svg')
require('../images/icons/logo_sv.svg')
require('../images/icons/externe_link.svg')
require('../images/icons/check.svg')
require('../images/icons/play.svg')
require('../images/icons/close.svg')
require('../images/icons/plus.svg')
require('../images/icons/tag-active.svg')
require('../images/icons/download.svg')
require('../images/icons/download_link.svg')
require('../images/icons/routenplaner.svg')
require('../images/icons/exclamation-mark.svg')
require('../images/icons/check-circle.svg')
require('../images/icons/newsletter.svg')
require('../images/icons/close_white.svg')

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        history: historyStore
    },
    state: {
        config: {},
        filter: {},
        browserFeatures: {}
    },
    mutations: {
        addFilter: function (state, value) {
            state.filter[value.id] = value.data
        },
        addBrowserFeature: function (state, value) {
            state.browserFeatures[value] = true
        },
        addConfig: function (state, value) {
            state.config = value
        }
    }
})

var data = {
    grid: false
}

Vue.component('sv-historyviz', () => import(/* webpackChunkName: "svHistoryviz" */ './components/visualization/history/history.vue'))
Vue.component('sv-co2', () => import(/* webpackChunkName: "svco2" */ './components/visualization/klimareport/co2/co2.vue'))
Vue.component('svgooglemaps', () => import(/* webpackChunkName: "svgooglemaps" */ './components/svgooglemaps.vue'))
Vue.component('svfilter', () => import(/* webpackChunkName: "svfilter" */ './components/filter/svfilter.vue'))
Vue.component('svfilteroptionslinks', () => import(/* webpackChunkName: "svfilteroptionslinks" */ './components/filter/svfilteroptionslinks.vue'))
Vue.component('svfilteronpageoptionlinks', () => import(/* webpackChunkName: "svfilteronpageoptionlinks" */ './components/filter/svfilteronpageoptionlinks.vue'))

var init = function () {
    window.vm = new Vue({
        el: '#app',
        store: store,
        data: data,
        directives: {
            imagesLoaded
        },
        components: {
            svnewsletter,
            svgridlayout,
            svCookieLayer,
            svToggleContent
        },
        mounted: function () {
            // remove dist stylesheet for development because it's compiled in instantly and added with JS dynamically
            if (process.env.NODE_ENV === 'development') {
                var elem = document.getElementById('main-stylesheet')
                if (elem) {
                    elem.parentNode.removeChild(elem)
                }
            }
            if (this.grid) {
                this.showGrid()
            }

            this.getGlobalConfig()
            this.detectBrowserFeatures()
            window.bus.$emit('vuejs-mounted')
        },
        methods: {
            detectBrowserFeatures: function () {
                if (this.supportsWebp()) {
                    this.$store.commit('addBrowserFeature', 'webp')
                }
            },
            getGlobalConfig: function () {
                this.$store.commit('addConfig', config)
            },
            supportsWebp: function () {
                if (!window.createImageBitmap) return false

                const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
                const blob = fetch(webpData).then(r => r.blob())
                return createImageBitmap(blob).then(() => true, () => false)
            },
            showGrid: function () {
                let grid = '<div class="debug-grid-overlay"><div class="container"><div class="columns"><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div><div class="column"><p class="notification is-warning has-text-centered"></p></div><div class="column"><p class="notification is-success has-text-centered"></p></div></div></div></div>'
                let gridOverlay = document.createElement('div')
                gridOverlay.innerHTML = grid
                this.$el.append(gridOverlay)
            },
            imagesloaded: function () {
                TweenMax.to(this.$el.querySelectorAll('#sv-preloader'), 0.6, {
                    opacity: 0,
                    display: 'none',
                    delay: 0.3,
                    onComplete: function () {
                        document.documentElement.style.overflowY = 'scroll'
                        EventBus.$emit('imagesloaded')

                        let declationWrapper = document.querySelector('.cookie-declaration-wrapper')
                        if (declationWrapper) {
                            let declationScript = document.createElement('script')

                            let metaLang = document.querySelector('[http-equiv="Content-Language"]')
                            let lang = false

                            if (metaLang) {
                                lang = metaLang.getAttribute('value')
                            }

                            declationScript.id = 'CookieDeclaration'

                            if (lang && lang !== 'de') {
                                declationScript.setAttribute('data-culture', 'EN')
                            }

                            declationScript.addEventListener('error', (event) => {
                                const fallbackMessage = document.getElementById('cookie-declaration-fallback')
                                if (fallbackMessage) {
                                    fallbackMessage.classList.add('show')
                                }
                            })
                            declationScript.src = 'https://consent.cookiebot.com/8bd4290b-4ee2-4650-8404-dff6a907df44/cd.js'
                            declationWrapper.appendChild(declationScript)
                        }
                    }
                })
            }
        }
    })
}

window.bus = new Vue()
window.bus.$on('reinit-vuejs-app', function () {
    window.vm.$destroy()
    init()
})
init()



// WEBPACK FOOTER //
// ./sv_cms/static/assets/vue/main.js